import { call, put } from "redux-saga/effects";
import { api, notify, queryBuilder } from "services";
import { requestErrorHandler } from "utils";
import {
	LookupTotemSchedulingActions,
} from "store/ducks/totem-scheduling";

export function* lookupTotemSchedulingRequest(action: any) {
	try {
		const { query = {}, onSuccess } = action;
		const queryString = queryBuilder(query);
		const { data: responseBody } = yield call(
			api.get,
			`/totem/schedulings?${queryString}`,
		);

		yield put(
			LookupTotemSchedulingActions.success(responseBody.data, responseBody.date),
		);
		if (onSuccess) onSuccess(responseBody);
	} catch (error) {
		const { errorMessage } = requestErrorHandler(error);
		notify("error", errorMessage);
		yield put(LookupTotemSchedulingActions.failure(errorMessage));
	}
}

export function* checkInTotemSchedulingRequest(action: any) {
	try {
		const { payload, onSuccess } = action;
		const { source, id } = payload;
		const { data: responseBody } = yield call(
			api.put,
			`/totem/schedulings/${source}/${id}/check-in`,
		);

		yield put(LookupTotemSchedulingActions.checkInSuccess());
		if (onSuccess) onSuccess(responseBody);
	} catch (error) {
		const { errorMessage } = requestErrorHandler(error);
		notify("error", errorMessage);
		yield put(LookupTotemSchedulingActions.checkInFailure(errorMessage));
	}
}

